import React from 'react'
import styles from './styles.module.scss'

export interface IOption {
  label: string
  value: string | number
}

export interface IGroupedOption {
  label: string
  options: IOption[]
}

interface InputSwitchButtonProps {
  options: IOption[] | IGroupedOption[]
  onChange: (newValue: any) => void
  value: any
}

const InputSwitchButton: React.FC<InputSwitchButtonProps> = ({
  options,
  value,
  onChange,
}) => {
  return (
    <div className={styles.wrapper}>
      {options.map((option, index) => (
        <button
          key={index}
          className={`${styles.option} ${
            value.value === option.value ? styles.active : ''
          }`}
          style={{ width: `${100 / options.length}%` }}
          onClick={() => onChange(option)}
        >
          <span>{option.label.toLowerCase()}</span>
        </button>
      ))}
    </div>
  )
}
export default InputSwitchButton
